import React, { useState, useEffect } from 'react';
import Wrapper from './styles';
import { useUserContext } from '../../context/user_context';
import { Link, useHistory, useLocation } from 'react-router-dom';
import useMounted from '../../hooks/useMounted';
import { toast } from 'react-toastify';
import { BsFillEyeFill, BsFillEyeSlashFill } from 'react-icons/bs';
import Button from '../../components/Button';
import { useUserDetailsContext } from '../../context/user_details_context';
import loginImage from '../../assets/loginImage.png';
import { Input } from '@chakra-ui/react';

function LoginPage() {
  const history = useHistory();
  const mounted = useMounted();
  const { loginUser, signInWithGoogle, verifyUserPhone } = useUserContext();
  const [phoneNumber, setPhoneNumber] = useState('');
  const [otp, setOtp] = useState('')
  const [mailOtp, setMailOtp]=useState("")
  const [isVerified, setIsVerified] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [visible, setVisible] = useState(false);
  const { postUserEmailToDatabase } = useUserDetailsContext();


  const handleVerifyPhoneNumber = async () => {
    setIsSubmitting(true);
    let res = await verifyUserPhone(phoneNumber, "login");
    if (res?.success) {
      setIsVerified(true)
      setMailOtp(res?.data?.otp)
      toast.success("Otp sent to Phone Number")
    }
    else{
      toast.error(res?.message)
    }
    setIsSubmitting(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!phoneNumber) {
      return toast.error('Please enter Phone Number');
    }
    if(otp != mailOtp) {
      return toast.error('Invalid OTP');
    }
    setIsSubmitting(true);

    try {
      const response = await loginUser(phoneNumber, otp);
      if (response.success) {
        toast.success('Login successful');
        history.push('/collections');
      } else {
        toast.error(response?.message);
      }
    } catch (error) {
      toast.error(
        error.message === 'Firebase: Error (auth/invalid-login-credentials).'
          ? 'Invalid email or password'
          : `Error: ${error.message}`
      );
      console.log(error.message);
    } finally {
      if (mounted.current) setIsSubmitting(false);
    }
  };


  useEffect(() => {
    document.title = 'Mukunda jewelers | Login';
  }, []);

  return (
    <div className='flex flex-col lg:flex-row justify-center items-center min-h-screen px-4 md:px-10 py-10'>
      <div className='flex flex-col gap-4 items-center bg-[#F5F5F5] shadow-lg rounded-2xl p-6 sm:p-8 md:p-10 w-full max-w-md md:max-w-lg lg:max-w-xl'>
        <h2 className='text-black font-[400] text-2xl text-center'>
          Customer login!
        </h2>
        <p className='text-[#556987] text-lg'>Sign into your account</p>

        {isVerified && (
          <div className='flex flex-col gap-4'>
            <Input
              type='number'
              placeholder='Enter your otp'
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />

            <Button
              className='bg-[#D3A143] hover:bg-[#b98a36] text-white rounded-lg px-4 py-2 w-full text-base md:text-lg font-medium'
              type='submit'
              onClick={handleSubmit}
            >
              Verify otp
            </Button>
          </div>
        )}
        {
          !isVerified && (
            <>
              <div className='flex flex-col gap-4 justify-start w-full'>
                <input
                  type='text'
                  name='number'
                  className='min-w-[100%] bg-transparent outline-none border border-[#A1A1AA] rounded-lg focus:outline-none p-2 text-sm'
                  placeholder='Phone number'
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                />
              </div>
              <Button
                className='bg-[#D3A143] text-white rounded-lg px-4 py-2 w-full'
                type='submit'
                onClick={handleVerifyPhoneNumber}
              >
                Login
              </Button>
              <p className='text-[#010535] text-sm'>
                Don't have an account?{' '}
                <Link to='/register'>
                  <span className='text-[#008FAB]'>Sign up</span>
                </Link>
              </p>
              <div className='seperator'>
                <span>or</span>
              </div>
              <Button
                className='bg-[#010535] hover:bg-[#b98a36] text-white rounded-lg px-4 py-2 w-full text-base md:text-lg'
                type='submit'

                onClick={async () => {
                  try {
                    let user = await signInWithGoogle();
                    await postUserEmailToDatabase(
                      user?.email,
                      user?.displayName
                    );
                    history.push('/');
                  } catch (err) {
                    toast.error(`Error: ${err.message}`);
                  }
                }}
              >
                Sign in with google
              </Button>
            </>
          )
        }
      </div>
      <div className='flex justify-center items-center py-4'>
        <img src={loginImage} alt='login image' />
      </div>
    </div>
  );
}

export default LoginPage;
